function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_13_703)"
}, React.createElement("path", {
  d: "M9.99665 0C4.48542 0 0 4.48542 0 9.99665C0 14.0999 2.4472 17.6198 6.00067 19.1686C5.96715 18.478 6.00067 17.6198 6.17499 16.8555C6.38284 16.0308 7.44888 11.4046 7.44888 11.4046C7.44888 11.4046 7.14046 10.7476 7.14046 9.81562C7.14046 8.33389 8.00536 7.22762 9.0714 7.22762C9.96983 7.22762 10.419 7.9182 10.419 8.74288C10.419 9.6413 9.83574 11.0158 9.52062 12.2963C9.27925 13.3624 10.0369 14.2273 11.1096 14.2273C13.007 14.2273 14.2809 11.7801 14.2809 8.9172C14.2809 6.71136 12.7992 5.08884 10.1106 5.08884C7.07342 5.08884 5.1827 7.36172 5.1827 9.88267C5.1827 10.7476 5.42407 11.3644 5.83976 11.8471C6.01408 12.055 6.0476 12.1555 5.98056 12.3969C5.94703 12.5712 5.80624 13.0204 5.77271 13.1881C5.70567 13.4294 5.49782 13.53 5.25645 13.4294C3.84177 12.8461 3.22494 11.3242 3.22494 9.60107C3.22494 6.77171 5.6051 3.35903 10.3654 3.35903C14.1938 3.35903 16.708 6.11465 16.708 9.08481C16.708 13.0137 14.5357 15.9437 11.3309 15.9437C10.2648 15.9437 9.22561 15.3604 8.88367 14.7033C8.88367 14.7033 8.30037 17.0164 8.1931 17.4589C7.98525 18.2166 7.56956 19.0077 7.1941 19.5977C8.09252 19.8726 9.058 20.0134 10.0235 20.0134C15.5414 20.0134 20.0201 15.528 20.0201 10.0168C20.0201 4.50553 15.5146 0 9.99665 0Z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_13_703"
}, React.createElement("rect", {
  width: 20,
  height: 20.0335
})));

var SvgIconPinterest = function SvgIconPinterest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPinterest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconPinterest.3736104e.svg";
export { ForwardRef as ReactComponent };